import ProductHighlightItem from './ProductHighlightItem';

export default ProductHighlightItem;
